import { useApiFetch, useGuardedEffect } from "@p0security/frontend-core";
import { ErrorDisplay } from "@p0security/frontend-core/react";
import { Catalog } from "@p0security/shared/types/catalog";
import { Spin } from "@p0security/ui";
import { useState } from "react";

import { CatalogContext } from "./context";

export const CatalogProvider: React.FC<React.PropsWithChildren<object>> = ({
  children,
}) => {
  const [error, setError] = useState<string>();
  const [value, setValue] = useState<Catalog>();
  const apiFetch = useApiFetch(setError);

  useGuardedEffect(
    (cancellation) => async () => {
      try {
        const response = await apiFetch("catalog", {
          method: "GET",
        });
        if (!response || cancellation.isCancelled) return;
        setValue((await response.json()) as Catalog);
      } catch (error: any) {
        return setError(String(error));
      }
    },
    [apiFetch],
    setError
  );
  return value ? (
    <CatalogContext.Provider value={value}>{children}</CatalogContext.Provider>
  ) : error ? (
    <ErrorDisplay error={error} title="Could not load IAM Risk Catalog" />
  ) : (
    <Spin />
  );
};
